
var cookiesTitle = "Aviso:",  
      cookiesDesc = "Utilizamos dados pessoais, cookies e tecnologias semelhantes de acordo com nossos <a href='https://www.bndes.gov.br/wps/portal/site/home/acesso-a-informacao/termos-de-uso-e-politica-de-privacidade-do-site-do-bndes' target='_blank'>termos de uso e politica de privacidade</a>. <br>Ao continuar navegando, você concorda com essas condições.",         
      cookiesButton = "Entendi"; 
function pureFadeIn(e, o) 
{ 
  var i = document.getElementById(e); 
  i.style.opacity = 0, 
    i.style.display = o || "block", 
  function e() 
  { 
    var o = parseFloat(i.style.opacity); 
    (o += .02) > 1 || (i.style.opacity = o, requestAnimationFrame(e)) 
  }() 
} 

function pureFadeOut(e) 
{ 
  var o = document.getElementById(e); 
  o.style.opacity = 1, function e() 
  { 
    (o.style.opacity -= .02) < 0 ? o.style.display = "none" : requestAnimationFrame(e) 
  }() 
} 

function setCookie(e, o, i) 
{ 
  var t = ""; if (i) 
  { 
    var n = new Date; 
    n.setTime(n.getTime() + 24 * i * 60 * 60 * 1e3), 
      t = "; expires=" + n.toUTCString() 
  } 

  document.cookie = e + "=" + (o || "") +";secure"+ t + ";sameSite=Strict" + "; path=/"
} 

function getCookie(e) 
{ 
  for (var o = e + "=", i = document.cookie.split(";"), t = 0; t < i.length; t++) 
  { 
    for (var n = i[t]; " " == n.charAt(0);)
      n = n.substring(1, n.length);
      if (0 == n.indexOf(o)) 
        return n.substring(o.length, n.length) 
  } 
  return null 
} 

function eraseCookie(e) 
{ 
  document.cookie = e + "=; Max-Age=-99999999;" 
} 

function cookiesConsent() 
{ 
  getCookie("cpc") || (
    document.body.innerHTML += '<div class="cookies" id="cookies">'
                                    +'<div> <b class="cookies-title">' + cookiesTitle + '</b> '
                                          +'<b class="cookies-desc">' + cookiesDesc + '</b> '
                                          +'<b class="cookies-button">'
                                              +'<a id="dismiss-consent-btn"> ' + cookiesButton + "</a>"
                                          +"</b>"
                                    +"</div>"
                                +"</div>", 
                              pureFadeIn("cookies"))
    const btn = document.getElementById("dismiss-consent-btn");
    if (btn) {
        btn.addEventListener("click", cookiesDismiss);
    }                                 
} 

function cookiesDismiss() 
{ 
  setCookie("cpc", "1", 10), pureFadeOut("cookies");
  window.location.reload(); 
} 

window.onload = function () 
{ 
  cookiesConsent() 
};

